import React from "react";
import { aiExportChatHistory } from "../../../../api/api";
import useAiTools from "../../../../hooks/useAiTools";
import useApi from "../../../../hooks/useApi";
import { getSkillMetrics } from "../../../../state/ai/runMetrics";
import { useChatHistory } from "../../../../state/api/ai/useChatHistory";
import { useSession } from "../../../../state/api/session/useSession";
import { Doc, Skill } from "../../../../types";
import Button from "../../buttons/Button";

interface Props {
  skill?: string;
  skillMeta?: Doc<Skill>;
}

const slug = (v: string) => (v || "chat")
  .trim()
  .replace(/[^a-zA-Z0-9]+/g, "_")
  .replace(/^_+|_+$/g, "")
  .toLowerCase() || "chat";

const today = () => {
  const d = new Date();
  const p = (v: number) => v.toString().padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export default function ExportChatButton(props: Props) {

  const { skill, skillMeta } = props;

  const { session } = useSession();
  const { chatHistory } = useChatHistory({ skill: skill! }, { enabled: !!skill });
  const { downloadFile } = useAiTools();

  const callApi = useApi();

  if (!session?.isAdmin || !skill || !chatHistory?.length) {
    return null;
  }

  return (
    <Button
      variant="subtle"
      icon="filetype-json"
      text="Export"
      onClick={async () => {
        const res = await callApi(aiExportChatHistory({ skill }));

        if (!res.success) {
          return;
        }

        const name = skillMeta?.label || skillMeta?.skill_id || res.data?.skill?.label || res.data?.skill?.skill_id || "chat";

        await downloadFile({
          filename: `${slug(name)}_${today()}.json`,
          mimeType: "application/json",
          content: JSON.stringify({ ...res.data, localMetrics: getSkillMetrics(skill) }, null, 2)
        });
      }}
    />
  )
}
